const listBreadcrumb = {
  text: 'route.list',
  to: 'list',
  link: true
}

export default [
  {
    path: '/boroughs',
    name: 'Boroughs',
    component: () => import('@/views/noXmlTables/Boroughs.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.boroughs',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/entry-requirements',
    name: 'EntryRequirements',
    component: () => import('@/views/noXmlTables/EntryRequirements.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.entryRequirements',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/ot-statuses',
    name: 'OTStatuses',
    component: () => import('@/views/noXmlTables/OTStatuses.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.otStatuses',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/ot-units',
    name: 'OTUnits',
    component: () => import('@/views/noXmlTables/OTUnits.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.otUnits',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/similar-courses',
    name: 'SimilarCourses',
    component: () => import('@/views/noXmlTables/SimilarCourses.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.similarCourses',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/refund-rates',
    name: 'RefundRates',
    component: () => import('@/views/noXmlTables/RefundRates.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.refundRates',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/nsr-units',
    name: 'NSRUnits',
    component: () => import('@/views/noXmlTables/NSRUnits.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.nsrUnits',
          disabled: true
        }
      ]
    }
  },
  {
    path: '/wish-statuses',
    name: 'WishStatuses',
    component: () => import('@/views/noXmlTables/WishStatuses.vue'),
    meta: {
      breadcrumbs: [
        listBreadcrumb,
        {
          text: 'kodeverkTable.title.wishStatuses',
          disabled: true
        }
      ]
    }
  }
]
